import { App } from 'vue'
import Select from '@/components/Form/Select.vue'
import FolderSelector from '@/components/Form/FolderSelector.vue'

export default {
  install(app: App, opt: any) {
    app.component('form-select', Select)
    app.component('folder-selector', FolderSelector)
  },
}
